"use strict";
ui.loadTemplateFile("charactercreate.html");

class CharacterCreateDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _name: any;
    _gender: any;
    _face: any;
    _hairStyle: any;
    _hairColor: any;
    _genderIndex: any;
    _faceIndex: any;
    _hairStyleIndex: any;

    static Genders = [
        [0, "Male"],
        [1, "Female"],
    ];

    static Faces = [
        [1, "1"],
        [8, "2"],
        [15, "3"],
        [22, "4"],
        [29, "5"],
        [36, "6"],
        [43, "7"],
        [50, "8"],
        [57, "9"],
    ];

    static HairStyles = [
        [0, "1"],
        [5, "2"],
        [10, "3"],
        [15, "4"],
        [20, "5"],
        [25, "6"],
        [30, "7"],
    ];

    constructor() {
        super("charactercreate.html");

        this._name = ui.textbox(this, ".textbox.name");
        this._gender = ui.label(this, ".label.gender");
        this._face = ui.label(this, ".label.face");
        this._hairStyle = ui.label(this, ".label.hair-style");
        this._hairColor = ui.label(this, ".label.hair-color");

        ui.button(this, ".button.prev.gender").on(
            "clicked",
            this._onPrevGender.bind(this)
        );
        ui.button(this, ".button.next.gender").on(
            "clicked",
            this._onNextGender.bind(this)
        );

        ui.button(this, ".button.prev.face").on(
            "clicked",
            this._onPrevFace.bind(this)
        );
        ui.button(this, ".button.next.face").on(
            "clicked",
            this._onNextFace.bind(this)
        );

        ui.button(this, ".button.prev.hair-style").on(
            "clicked",
            this._onPrevHairStyle.bind(this)
        );
        ui.button(this, ".button.next.hair-style").on(
            "clicked",
            this._onNextHairStyle.bind(this)
        );

        //   ui.button(this, '.button.prev.hair-color').on('clicked', this._onPrevHairColor.bind(this));
        //   ui.button(this, '.button.next.hair-color').on('clicked', this._onNextHairColor.bind(this));

        ui.button(this, ".button.create").on("clicked", this._onCreate.bind(this));
        ui.button(this, ".button.cancel").on("clicked", this._onCancel.bind(this));

        this._genderIndex = 0;
        this._faceIndex = 0;
        this._hairStyleIndex = 0;
        //   this._hairColorIndex = 0;
        this._update();
    }

    _onCreate() {
        const name = this._name.text();

        if (name.length < 4 || name.length > 20) {
            ui.messageBox(
                "Character name must be between 4 and 20 characters long."
            );
            return;
        }

        if (!name.match(/^[A-Za-z0-9]*$/)) {
            ui.messageBox(
                "Character name must only contain the characters [A-Z], [a-z], [0-9]."
            );
            return;
        }

        this.emit(
            "create",
            name,
            CharacterCreateDialog.Genders[this._genderIndex][0],
            CharacterCreateDialog.Faces[this._faceIndex][0],
            CharacterCreateDialog.HairStyles[this._hairStyleIndex][0]
            // CharacterCreateDialog.HairColors[this._hairColorIndex][0]
        );
    }

    _onCancel() {
        this.emit("cancel");
        this.close();
    }

    _update() {
        this._gender.text(CharacterCreateDialog.Genders[this._genderIndex][1]);
        this._face.text(CharacterCreateDialog.Faces[this._faceIndex][1]);
        this._hairStyle.text(
            CharacterCreateDialog.HairStyles[this._hairStyleIndex][1]
        );
        //   this._hairColor.text(CharacterCreateDialog.HairColors[this._hairColorIndex][1]);
    }

    _onPrevGender() {
        this._genderIndex--;

        if (this._genderIndex < 0) {
            this._genderIndex = CharacterCreateDialog.Genders.length - 1;
        }

        this._update();
        this.emit(
            "change_gender",
            CharacterCreateDialog.Genders[this._genderIndex][0]
        );
    }

    _onNextGender() {
        this._genderIndex++;

        if (this._genderIndex >= CharacterCreateDialog.Genders.length) {
            this._genderIndex = 0;
        }

        this._update();
        this.emit(
            "change_gender",
            CharacterCreateDialog.Genders[this._genderIndex][0]
        );
    }

    _onPrevFace() {
        this._faceIndex--;

        if (this._faceIndex < 0) {
            this._faceIndex = CharacterCreateDialog.Faces.length - 1;
        }

        this._update();
        this.emit(
            "change_face",
            CharacterCreateDialog.Faces[this._faceIndex][0]
        );
    }

    _onNextFace() {
        this._faceIndex++;

        if (this._faceIndex >= CharacterCreateDialog.Faces.length) {
            this._faceIndex = 0;
        }

        this._update();
        this.emit(
            "change_face",
            CharacterCreateDialog.Faces[this._faceIndex][0]
        );
    }

    _onPrevHairStyle() {
        this._hairStyleIndex--;

        if (this._hairStyleIndex < 0) {
            this._hairStyleIndex = CharacterCreateDialog.HairStyles.length - 1;
        }

        this._update();
        this.emit(
            "change_hair_style",
            CharacterCreateDialog.HairStyles[this._hairStyleIndex][0]
        );
    }

    _onNextHairStyle() {
        this._hairStyleIndex++;

        if (this._hairStyleIndex >= CharacterCreateDialog.HairStyles.length) {
            this._hairStyleIndex = 0;
        }

        this._update();
        this.emit(
            "change_hair_style",
            CharacterCreateDialog.HairStyles[this._hairStyleIndex][0]
        );
    }

    // _onPrevHairColor() {
    //   this._hairColorIndex--;

    //   if (this._hairColorIndex < 0) {
    //     this._hairColorIndex = CharacterCreateDialog.HairColors.length - 1;
    //   }

    //   this._update();
    //   this.emit('change_hair_color', CharacterCreateDialog.HairColors[this._hairColorIndex][0]);
    // }

    // _onNextHairColor() {
    //   this._hairColorIndex++;

    //   if (this._hairColorIndex >= CharacterCreateDialog.HairColors.length) {
    //     this._hairColorIndex = 0;
    //   }

    //   this._update();
    //   this.emit('change_hair_color', CharacterCreateDialog.HairColors[this._hairColorIndex][0]);
    // }
}

ui.CharacterCreateDialog = CharacterCreateDialog;
ui.characterCreateDialog = function () {
    return new ui.CharacterCreateDialog();
};
